import { connect } from 'react-redux'
import Toaster from './component'
import { getDisplayToasts, getButtonEnabled, removeToast, buttonClicked } from '../../data'
import { getLayout } from '../../imports'

function mapStateToProps(state) {
    return {
        showButton: getButtonEnabled(state),
        toasts: getDisplayToasts(state),
        position: 'topRight',
        animation: 'none',
        layout: getLayout(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        removeToast: (id, isMessage) => {
            dispatch(removeToast(id, isMessage))
        },
        toggleMenu: () => {
            dispatch(buttonClicked())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Toaster)



// WEBPACK FOOTER //
// ./src/features/Toaster/components/Toaster/index.js